import { render } from "./XIconSolidCalendar.vue?vue&type=template&id=d31cb4f6"
import script from "./XIconSolidCalendar.vue?vue&type=script&lang=js"
export * from "./XIconSolidCalendar.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidCalendar.vue"]])

export default __exports__